import React, {createContext, useEffect, useState} from "react"
import moment from "moment"
import UseDebounce from "../../shared/UseDebounce"
import parseToken from "../../../helpers/parseToken"
import {searchCustomersList} from "../../../services/api/apListCustomers"

export const Context = createContext({})

export const Provider = (props) => {
    const {params = {}} = props
    let newParams = {...params}
    if (params.createDateFrom !== undefined) newParams = {...newParams, createDateFrom: moment(params.createDateFrom)}
    if (params.createDateTo !== undefined) newParams = {...newParams, createDateTo: moment(params.createDateTo)}
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(50)
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [listCustomers, setListCustomers] = useState('')
    const [filters, setFilters] = useState({
        createDateFrom: moment().startOf('month'),
        createDateTo: moment().endOf('month'),
        ...newParams
    })

    const debouncedCustomerListCode = UseDebounce(filters.customerListCode, 500)
    const debouncedCreatedBy = UseDebounce(filters.createdBy, 500)

    const _fetchListCustomers = async () => {
        setLoading(true)
        setError('')

        try {
            const info = parseToken()
            const payload = {
                ...filters,
                limit,
                page,
                userName: info.sub,
                createDateFrom: filters.createDateFrom.utcOffset(0).format(),
                createDateTo: filters.createDateTo.utcOffset(0).format()
            }

            const response = await searchCustomersList(payload)

            const {success, data, error_message, totalRecord} = response

            if (parseInt(success) !== 1) {
                setLoading(false)
                return setError(error_message)
            }

            setLoading(false)
            setListCustomers(data)
            setTotal(totalRecord)
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    const _setFiltersState = (params) => {
        setFilters({
            ...filters,
            ...params
        })
    }

    useEffect(() => {
        _fetchListCustomers()
        // eslint-disable-next-line
    }, [debouncedCustomerListCode, debouncedCreatedBy, filters.createDateFrom, filters.createDateTo, filters.source, page, limit, filters.status, filters.rating])

    return (
        <Context.Provider
            value={{
                listCustomers,
                filters,
                total,
                page,
                limit,
                loading,
                error,
                setPage,
                setLimit,
                fetchListCustomers: _fetchListCustomers,
                setFiltersState: _setFiltersState
            }}
        >
            {props.children}
        </Context.Provider>
    )
}

export {
    Context as ListCustomersContext,
    Provider as ListCustomersContextProvider,
} from "./ListCustomersContext"
